// src/app/redux/sagas/paramDomainesThemesSaga.js

import {  call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchDomainesSuccess,
    fetchDomainesFail,
    fetchThemesSuccess,
    fetchThemesFail,
    fetchThemesByDomaineSuccess,
    fetchThemesByDomaineFail,
    createDomaineSuccess,
    createDomaineFail,
    updateDomaineSuccess,
    updateDomaineFail,
    deleteDomaineSuccess,
    deleteDomaineFail,
    createThemeSuccess,
    createThemeFail,
    updateThemeSuccess,
    updateThemeFail,
    deleteThemeSuccess,
    deleteThemeFail,
    setParamDomainesThemesLoading,

    DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS,
    DOWNLOAD_DOMAINES_TEMPLATE_FAIL,
    DOWNLOAD_THEMES_TEMPLATE_SUCCESS,
    DOWNLOAD_THEMES_TEMPLATE_FAIL,
    IMPORT_DOMAINES_EXCEL_SUCCESS,
    IMPORT_DOMAINES_EXCEL_FAIL,
    IMPORT_THEMES_EXCEL_SUCCESS,
    IMPORT_THEMES_EXCEL_FAIL,
    fetchDomainesRequest,
    fetchThemesRequest,
} from "../actions/paramDomainesThemesActions";

import { API_BASE_URL, getRequest, postRequest, putRequest,getBlobRequest, deleteRequest } from "../../../api";
// ⚠️ adapte le chemin si besoin (chez toi c’est souvent "../../../../api" selon l’emplacement)

const getUid = () => sessionStorage.getItem("uid"); // si ton projet stocke uid
const getToken = () => sessionStorage.getItem("token"); // si besoin

export function* fetchDomainesSaga() {
    const url = `${API_BASE_URL}/api/domaines`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchDomainesSuccess(resp.data));
    } catch (e) {
        yield put(fetchDomainesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

export function* fetchThemesSaga() {
    const url = `${API_BASE_URL}/api/themes`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchThemesSuccess(resp.data));
    } catch (e) {
        yield put(fetchThemesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

export function* fetchThemesByDomaineSaga(action) {
    const { domaineId } = action.payload;
    const url = `${API_BASE_URL}/api/themes/by-domaine/${domaineId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchThemesByDomaineSuccess(resp.data));
    } catch (e) {
        yield put(fetchThemesByDomaineFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

// ---- Domaine (multipart: payload + image) ----


const buildDomaineFormData = (p) => {
    const fd = new FormData();
    fd.append("reference", p.reference || "");
    fd.append("nom", p.nom || "");
    fd.append("description", p.description || "");
    fd.append("couleur", p.couleur || "#204385");
    fd.append("actif", p.actif ? "true" : "false");
    if (p.imageFile instanceof File) fd.append("image", p.imageFile);
    return fd;
};

export function* createDomaineSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/domaines`;
    yield put(setParamDomainesThemesLoading(true));

    try {
        const fd = buildDomaineFormData(action.payload);

        const resp = yield call(postRequest, {
            url,
            data: fd,
            token,
            // IMPORTANT : laisser axios mettre le content-type automatiquement
            // headers: { "Content-Type": "multipart/form-data" }  <-- pas nécessaire
        });

        yield put(createDomaineSuccess(resp.data));
        yield put(fetchDomainesRequest());
        yield put(setParamDomainesThemesLoading(false));
    } catch (e) {
        yield put(createDomaineFail(e.response?.data?.message || e.message));
        yield put(setParamDomainesThemesLoading(false));
    }
}

export function* updateDomaineSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/domaines/${id}`;
    yield put(setParamDomainesThemesLoading(true));

    try {
        const fd = buildDomaineFormData(payload);

        const resp = yield call(putRequest, {
            url,
            data: fd,
            token,
        });

        yield put(updateDomaineSuccess(resp.data));
        yield put(fetchDomainesRequest());
        yield put(setParamDomainesThemesLoading(false));
    } catch (e) {
        yield put(updateDomaineFail(e.response?.data?.message || e.message));
        yield put(setParamDomainesThemesLoading(false));
    }
}

export function* deleteDomaineSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/domaines/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteDomaineSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Domaine supprimé", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteDomaineFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression domaine", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

// ---- Theme (JSON) ----
export function* createThemeSaga(action) {
    const url = `${API_BASE_URL}/api/themes`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createThemeSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Thème ajouté", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createThemeFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur ajout thème", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

export  function* updateThemeSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/themes/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateThemeSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Thème modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateThemeFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur modification thème", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}

export function* deleteThemeSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/themes/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setParamDomainesThemesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteThemeSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Thème supprimé", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteThemeFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression thème", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setParamDomainesThemesLoading(false));
    }
}


function downloadBlobAsFile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

/* =========================
   DOWNLOAD TEMPLATES
========================= */

export function* downloadDomainesTemplateSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/domaines/template`;



        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "template_domaines.xlsx");
        yield put({ type: DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_DOMAINES_TEMPLATE_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template domaines échoué" });
    }
}

export function* downloadThemesTemplateSaga() {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/themes/template`;


        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });


        downloadBlobAsFile(new Blob([res.data]), "template_themes.xlsx");
        yield put({ type: DOWNLOAD_THEMES_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_THEMES_TEMPLATE_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template thèmes échoué" });
    }
}

/* =========================
   IMPORT EXCEL + REVIEW
========================= */

export function* importDomainesExcelSaga(action) {
    const token = sessionStorage.getItem("token");

    try {
        const url = `${API_BASE_URL}/api/domaines/import`;
        const fd = new FormData();
        fd.append("file", action.payload);

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
        });

        yield put({ type: IMPORT_DOMAINES_EXCEL_SUCCESS, payload: res.data });

        // refresh
        yield put(fetchDomainesRequest());

        Swal.fire({
            icon: "success",
            title: "Import Domaines terminé",
            text: `${res.data.createdCount} créés, ${res.data.skippedCount} ignorés`,
        });
    } catch (e) {
        yield put({
            type: IMPORT_DOMAINES_EXCEL_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur import", text: "Import domaines échoué" });
    }
}

export function* importThemesExcelSaga(action) {
    const token = sessionStorage.getItem("token");

    try {
        const url = `${API_BASE_URL}/api/themes/import`;
        const fd = new FormData();
        fd.append("file", action.payload);

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
        });

        yield put({ type: IMPORT_THEMES_EXCEL_SUCCESS, payload: res.data });

        // refresh
        yield put(fetchThemesRequest());

        Swal.fire({
            icon: "success",
            title: "Import Thèmes terminé",
            text: `${res.data.createdCount} créés, ${res.data.skippedCount} ignorés`,
        });
    } catch (e) {
        yield put({
            type: IMPORT_THEMES_EXCEL_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur import", text: "Import thèmes échoué" });
    }
}
